import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError, ok } from "@nju/result";
import { IInitialSettings, ISetSimCardSettingsResult } from "./types";

interface ISetSimCardSettingsParams {
  productId: string | undefined;
  isAcrActive: IInitialSettings["isAcrActive"];
  isRoamingActive: IInitialSettings["isRoamingActive"];
  isVoiceMailActive: IInitialSettings["isVoiceMailActive"];
}

export async function setSimCardSettings({
  productId,
  isAcrActive,
  isRoamingActive,
  isVoiceMailActive,
}: ISetSimCardSettingsParams): Promise<ISetSimCardSettingsResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/products/${productId}/characteristics`,
    {
      method: "patch",
      headers: {
        "Accept-Language": "pl",
        "Client-Id": process.env.NEXT_PUBLIC_CLIENT_ID || "unknown",
      },
      json: {
        characteristic: [
          {
            name: "acr",
            value: isAcrActive ? "Y" : "N",
          },
          {
            name: "roaming",
            value: isRoamingActive ? "Y" : "N",
          },
          {
            name: "voiceMailLostCalls",
            value: isVoiceMailActive ? "VM" : "LC",
          },
        ],
      },
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
